import React from 'react'
import { RouteComponentProps } from '@reach/router'

const Anagrafica: React.FC<RouteComponentProps> = ({ children }) => {
  return <div>{children}</div>
}

export default Anagrafica
